import { render, staticRenderFns } from "./FuelSurcharge.vue?vue&type=template&id=1edb830a&scoped=true&"
import script from "./FuelSurcharge.vue?vue&type=script&lang=ts&"
export * from "./FuelSurcharge.vue?vue&type=script&lang=ts&"
import style0 from "./FuelSurcharge.vue?vue&type=style&index=0&id=1edb830a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edb830a",
  null
  
)

export default component.exports